import React from "react";
import LandingPage from "./LandingPage/LandingPage";

export default () => (
  <LandingPage/>
);
